import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDeferredPromise } from '../useDeferredPromise'
import { SCRIPT_STATUS_ERROR, SCRIPT_STATUS_READY, useScript } from './useScript'

// useDeferredScript return a promise that resolve when script ready
export const useDeferredScript = (script) => {
	const [paused, setPaused] = useState(true)
	const _script = useMemo(() => ({ ...script, paused }), [script, paused])

	const status = useScript(_script)

	const { defer, deferRef } = useDeferredPromise()
	const deferredPromise = useMemo(() => defer().promise, [defer])

	// This useEffect is separate so that components using useDeferredScript
	// can use useEffect on status for initialization purposes, for example.
	useEffect(() => {
		if (status === SCRIPT_STATUS_READY) {
			deferRef.current.resolve(true)
		} else if (status === SCRIPT_STATUS_ERROR) {
			deferRef.current.reject(false)
		}
	}, [status, deferRef])

	const load = useCallback(() => {
		setPaused(false)
		return deferredPromise
	}, [deferredPromise])

	return { status, isReadyPromise: deferredPromise, load }
}
